var React = require('react');

function Poo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M451.4 369.1A71.77 71.77 0 0 0 408 240h-14.1A63.74 63.74 0 0 0 352 128h-5.9a94.61 94.61 0 0 0 5.9-32 96 96 0 0 0-96-96 93.1 93.1 0 0 0-15.1 1.5A79.79 79.79 0 0 1 176 128h-16a63.74 63.74 0 0 0-41.9 112H104a71.77 71.77 0 0 0-43.4 129.1A71.9 71.9 0 0 0 72 512h368a71.9 71.9 0 0 0 11.4-142.9zM320 256a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm-128 0a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53a8.2 8.2 0 0 1 7.8-11h175.4a8.2 8.2 0 0 1 7.8 11z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 256a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-128 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

Poo.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Poo;

Poo.default = Poo;
